import {
  faChevronLeft,
  faChevronRight,
  faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import { Component, computed, HostBinding, input, output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { ButtonComponent } from '../../button/button.component';

export interface CheckoutContainerData {
  fullWidth?: boolean;
  backBtnText?: string;
  forwardBtnText?: string;
  showBackBtn?: boolean;
  showForwardBtn?: boolean;
  showBackBtnIcon?: boolean;
  showForwardBtnIcon?: boolean;
  showBackgroundColor?: boolean;
}

@Component({
  selector: 'boels-checkout-container',
  templateUrl: './checkout-container.component.html',
  styleUrls: ['./checkout-container.component.scss'],
  imports: [TranslocoModule, FontAwesomeModule, ButtonComponent],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['user', 'checkout'],
    },
  ],
})
export class CheckoutContainerComponent {
  containerData = input<CheckoutContainerData>();

  backBtnClicked = output<void>();
  forwardBtnClicked = output<void>();

  protected readonly faChevronLeft = faChevronLeft;
  protected readonly faChevronRight = faChevronRight;
  protected readonly containerDataValues = computed(() => {
    const {
      fullWidth = false,
      showBackBtn = true,
      showForwardBtn = true,
      showBackBtnIcon = true,
      showForwardBtnIcon = true,
      showBackgroundColor = true,
      backBtnText = 'user.back',
      forwardBtnText = 'user.continue',
    } = this.containerData() || {};
    return {
      fullWidth,
      showBackBtn,
      showForwardBtn,
      showBackBtnIcon,
      showForwardBtnIcon,
      showBackgroundColor,
      backBtnText,
      forwardBtnText,
    };
  });

  @HostBinding('class.no-background') get noBackground() {
    return !this.containerDataValues().showBackgroundColor;
  }

  @HostBinding('class.full-width') get fullWidth() {
    return this.containerDataValues().fullWidth;
  }

  protected readonly faPaperPlane = faPaperPlane;
}
